import { tv } from "@ui/lib/tv";

export const persistentSheet = tv({
  slots: {
    // The view ignores pointers outside the traveling card so the Islands
    // (map, chrome) beneath stay reachable; positioned via inline top/height
    // to the track region (viewport top — the sheet slides behind the TopBar
    // — to above any bottom nav).
    view: "pointer-events-none fixed inset-x-0 z-(--z-persistent-sheet)",
    // The traveling card. `h-full` fills the track; Silk translates it between
    // detents.
    content: [
      "pointer-events-auto mx-auto flex h-full w-full max-w-[640px] flex-col",
      "rounded-t-[20px] bg-white",
      "shadow-sheet",
    ],
    // The peek strip's drag surface (see PersistentSheet.tsx). h-auto: Silk
    // defaults the wrapper to full height, which would shove the body below
    // the fold — the strip must hug its chrome.
    chromeWrapper: "h-auto shrink-0",
    chrome: "flex h-auto flex-col",
    handle: "flex w-full shrink-0 select-none items-center justify-center pt-3 pb-2",
    // 60×4 pill, 12px from the sheet top (Figma map-sheet handle). The pill is
    // the Sheet.Handle button itself — Silk hides Handle children visually.
    handlePill:
      "h-1 w-[60px] shrink-0 cursor-grab touch-none rounded-full border-0 bg-neutral-100 p-0 outline-none focus-visible:ring-2 focus-visible:ring-neutral-400 focus-visible:ring-offset-4 active:cursor-grabbing",
    header: "shrink-0 select-none px-5 pt-2 pb-3",
    // A Silk Scroll.View — no overflow utilities here; Silk owns overflow.
    body: "min-h-0 flex-1 px-5 pb-6",
  },
});
